import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './price-trend')
);

const PriceTrendLoader = props => <LoadableComponent {...props} />;

export default PriceTrendLoader;
